import { SearchWorkerResult } from 'components/searchBox/types';
import { JobsiteFormSubmissionWorkerEdit } from 'containers/jobsiteFormSubmission/components/formSubmissionWorkers/types';
import { EditableEnhancedFormSubmissionWorker } from 'containers/jobsiteFormSubmission/types';
import { getFormattedPhoneNumber } from 'utils';

const getSearchWorkerResult = (
  jfsWorker: EditableEnhancedFormSubmissionWorker,
): SearchWorkerResult => {
  const { jobsitesInfo } = jfsWorker;
  const { jobsiteWorkerId, contractorWorker } = jfsWorker.jobsiteWorker ?? {};
  const { worker } = contractorWorker ?? {};
  const { firstName, lastName, email, phoneNumber } =
    worker?.user.identity ?? {};

  const jobsiteWorker =
    jobsitesInfo?.find((jw) => jw.jobsiteWorkerId === jobsiteWorkerId)
      ?.jobsiteWorker ?? jobsitesInfo?.[0]?.jobsiteWorker;

  return {
    id: worker.workerId,
    firstName,
    lastName,
    email,
    phone: getFormattedPhoneNumber(phoneNumber),
    quickCode: worker.quickCode,
    badgeId: jobsiteWorker?.stickerNumber,
    imageUrl: worker.profilePicture?.downloadUrl,
    jobsitesInfo,
    searchTerm: null,
  };
};

export const toJfsWorkerEdit = (
  jfsWorker?: EditableEnhancedFormSubmissionWorker,
): JobsiteFormSubmissionWorkerEdit =>
  jfsWorker
    ? {
        ...jfsWorker,
        editType: 'update',
        searchWorkerResult: getSearchWorkerResult(jfsWorker),
      }
    : null;
